import React from 'react';
import Button from '../common/Button';
import { MessageSquare } from 'lucide-react';

interface HeroProps {
  onTryFree: () => void;
}

const Hero: React.FC<HeroProps> = ({ onTryFree }) => {
  return (
    <div className="pt-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24 sm:pt-24 sm:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 leading-tight">
              Send Smart.<br/>Grow Fast.
            </h1>
            <p className="text-xl sm:text-2xl text-gray-600 max-w-2xl">
              AI-in-one tools for email, customer growth, and conversion — built for ease.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Button variant="primary" size="lg" onClick={onTryFree}>
                Try Free
              </Button>
              <Button variant="outline" size="lg">
                View Demo
              </Button>
            </div>
            <div className="flex items-center text-gray-500 text-sm">
              <svg className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>No credit card required</span>
            </div>
          </div>
          <div className="relative">
            <div className="relative rounded-xl shadow-2xl overflow-hidden bg-white">
              <img 
                src="https://images.pexels.com/photos/8294609/pexels-photo-8294609.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" 
                alt="CustMax Dashboard" 
                className="w-full"
              />
            </div>
            
            {/* Floating UI elements */}
            <div className="absolute top-[-2rem] right-[-1rem] bg-white rounded-lg shadow-lg p-4 animate-float">
              <div className="flex items-center space-x-2">
                <div className="h-3 w-3 bg-green-500 rounded-full"></div>
                <span className="font-medium text-sm">AI Suggestion Ready</span>
              </div>
            </div>
            
            <div className="absolute bottom-[-1rem] left-[-1rem] bg-white rounded-lg shadow-lg p-4 animate-float delay-200">
              <div className="flex items-center space-x-2">
                <div className="h-3 w-3 bg-blue-500 rounded-full"></div>
                <span className="font-medium text-sm">+28% Open Rate</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Live chat icon */}
      <div className="fixed bottom-6 right-6 z-40">
        <button className="bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg transition-all duration-300 hover:scale-110">
          <MessageSquare size={24} />
          <span className="sr-only">Live Chat</span>
        </button>
      </div>
    </div>
  );
};

export default Hero;